import { WSCard, WSText } from "@wingspanhq/fe-component-library";
import { queriesRequirements, queriesPayerRows } from "@query";
import { RequirementType } from "@wingspanhq/wingspan-api-sdk";

import { useSession } from "@hooks/useSession";
import { selectorSearchRowName } from "../../../shared/selectors/selectorSearchRowName";

export const CardPayoutMethodRequirementRequester = () => {
  const { accountId } = useSession();

  // TODO(v3-blocker): v1 also filtered on `payerPayeeEngagementIds != null`;
  // v3 `listPayeeRequirements` has no existence operator, so that constraint
  // is dropped.
  const queryRequirements =
    queriesRequirements.listPayeeRequirements.useQueryAll(
      {
        filter: {
          payeeAccountId: { in: [accountId] },
          type: { in: [RequirementType.PAYOUT_METHOD] }
        }
      },
      { enabled: !!accountId }
    );

  const payerIds = (queryRequirements.flatData || [])
    .map(requirement => requirement.payerAccountId)
    .filter((payerId): payerId is string => !!payerId);

  const queryPayers = queriesPayerRows.searchPayerRows.useQueryAll({
    filter: {
      payerAccountId: {
        anyOf: payerIds
      }
    }
  });

  const payerNames = (queryPayers.flatData || []).map(payer =>
    selectorSearchRowName(payer)
  );

  return (
    <WSCard header="Payout method">
      <WSText.ParagraphSm color="gray600">
        Complete your account setup by providing your payout method below as
        required by {payerNames.join(", ")} to receive payments from them.
      </WSText.ParagraphSm>
    </WSCard>
  );
};
